import { render } from "./GridPembayaranHutangDetail.vue?vue&type=template&id=60b97976"
import script from "./GridPembayaranHutangDetail.vue?vue&type=script&lang=js"
export * from "./GridPembayaranHutangDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__